
export const selectContacts = state => state.contacts;
export const selectFilter = state => state.filter;


